import { render, staticRenderFns } from "./AlphabetSoupIndex.vue?vue&type=template&id=33b36965&"
import script from "./AlphabetSoupIndex.vue?vue&type=script&lang=js&"
export * from "./AlphabetSoupIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports